/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidemailorpassword3Inputs */

const en_invalidemailorpassword3 = /** @type {(inputs: Invalidemailorpassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email or password.`)
};

const de_invalidemailorpassword3 = /** @type {(inputs: Invalidemailorpassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse oder Passwort ist ungültig.`)
};

/**
* | output |
* | --- |
* | "Invalid email or password." |
*
* @param {Invalidemailorpassword3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidemailorpassword3 = /** @type {((inputs?: Invalidemailorpassword3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidemailorpassword3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidemailorpassword3(inputs)
	return de_invalidemailorpassword3(inputs)
});
export { invalidemailorpassword3 as "invalidEmailOrPassword" }